import { render, staticRenderFns } from "./index_nx.vue?vue&type=template&id=efe5bdf2&scoped=true"
import script from "./index_nx.vue?vue&type=script&scoped=true&lang=js"
export * from "./index_nx.vue?vue&type=script&scoped=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe5bdf2",
  null
  
)

export default component.exports